import { useState } from 'react';
import { Translate } from 'react-i18nify';
import styles from './DetailedErrorMessage.module.scss';
import Button from '../../Button';
import ExpandableContent from '../ExpandableContent';

type Props = {
  error: ErrorWithStatus;
  color?: 'grey' | 'red';
};

export default function DetailedErrorMessage({ error, color = 'grey' }: Props) {
  const [detailsVisible, setDetailsVisible] = useState(false);

  return (
    <>
      <div className={`${styles.wrapper} ${styles[color]}`}>
        <div>
          Error {error.status}{' '}
          <strong>
            <Translate value={`network_error.${error.status}`} />
          </strong>
        </div>
        {error.cause ? (
          <Button variant="text" onClick={() => setDetailsVisible(!detailsVisible)}>
            {detailsVisible ? 'Dölj' : 'Visa'} detaljer
          </Button>
        ) : null}
      </div>
      {error.cause ? (
        <ExpandableContent expanded={detailsVisible}>
          <pre>{JSON.stringify(error.cause, null, 2)}</pre>
        </ExpandableContent>
      ) : null}
    </>
  );
}
